export default "__VITE_ASSET__DncMow0p__"